import AppButton from "@/components/AppButton.vue";
import EmptyState from "@/components/EmptyState.vue";
import ModalCodigo from "@/components/ModalCodigo.vue";
import Request from "@/ts/Request";
import Util from "@/ts/Util";
import HeaderColor from "orders-module/src/components/HeaderColor.vue";
import { Component, Vue } from "vue-property-decorator";
import ModalPixPending from "../../node_modules/orders-module/src/components/ModalPixPending.vue";

declare const fbq: any;

@Component({
  components: {
    ModalCodigo,
    HeaderColor,
    ModalPixPending,
    AppButton,
    EmptyState,
  },
})
export default class PaymentMethod extends Vue {
  cards: any = JSON.parse(sessionStorage.getItem("CREDIT_CARDS") || "[]");
  newCard: any = JSON.parse(sessionStorage.getItem("NEW_CC") || "{}");
  cardsParent: any = sessionStorage.getItem("CARDS_PARENT")
    ? JSON.parse(sessionStorage.getItem("CARDS_PARENT") || "{}")
    : null;
  LAST_NUMBERS: any = 0;
  FLAG_CARD: any = "";
  CREDIT_CARD_ID = -1;

  showModal = false;
  modalConfirm = false;
  modalVerify = false;
  msgVerify: any = "";
  deliverTo: any = sessionStorage.getItem("DELIVER_AT");
  store: any = JSON.parse(sessionStorage.getItem("STORE") || "[]");
  mainCartao: any = JSON.parse(sessionStorage.getItem("MAIN_CARTAO") || "{}");
  aceitaCC: any = sessionStorage.getItem("ACEITA_CC") || "";
  allPaymentMethods: any = JSON.parse(
    sessionStorage.getItem("ALL_PAYMENT_METHODS") || "[]"
  );
  paymentMethodSelected: any = sessionStorage.getItem("METHOD_SELECTED") || "";
  fullMethodSelected: any = JSON.parse(
    sessionStorage.getItem("FULL_METHOD_SELECTED") || "{}"
  );
  paymentMethods: Array<any> = JSON.parse(
    sessionStorage.getItem("ACCEPTED_PAYMENT_METHODS") || "[]"
  );
  organizationDta: any = JSON.parse(
    sessionStorage.getItem("ORGANIZATION_DATA") || "{}"
  );
  hasGatway = false;
  showPaymentWithApp = -1;
  showPaymentVoucher = -1;
  showPaymentOnDelivery = -1;
  showPaymentDelivery = -1;
  showPaymentPix = -1;
  showPaymentCP = -1;
  userId = sessionStorage.getItem("USER_ID");
  nrorg: any = sessionStorage.getItem("NRORG");
  FLAG = "";
  deliveryPaymentMethods: Array<object> = [];
  pixPaymentMethods: Array<any> = [];
  personalCreditAndConsumerDebitPaymentMethods: Array<any> = [];
  backButton: any = {
    iconClass: "fas",
    icon: "chevron-left",
    callback: this.goToPedido,
  };
  errorMessage =
    "Ocorreu um erro desconhecido. Por favor, tente de novo mais tarde.";
  showModalCpf = false;
  cpf = "";
  cpfError = "";
  userData: any = JSON.parse(sessionStorage.getItem("USER_DATA") || "{}");
  hasPixel: any = JSON.parse(sessionStorage.getItem("hasPixel") || "false");
  tab = 0;
  ordersPixPending: any = [];
  showModalPix = false;
  showModalMinimumPaymentError = false;

  mounted() {
    $("body").animate({ scrollTop: top }, 0);
    if (this.hasPixel) {
      fbq("trackCustom", "viewPaymentMethodsPage");
    }

    if (
      this.organizationDta.CONFIGURATIONS.GATEWAY &&
      this.organizationDta.CONFIGURATIONS.GATEWAY.MERCHANT_KEY
    ) {
      this.hasGatway = true;
    } else {
      this.hasGatway = false;
    }

    Util.setBackButtonBehavior(this.goBack);
    this.getStorePaymentType();
    this.checkPixPending();
  }

  getStorePaymentType() {
    try {
      const self = this;
      const req = new Request();
      req.route = "getStorePaymentType";
      req.body = {
        STORE_ID: sessionStorage.getItem("storeId"),
        NRORG: sessionStorage.getItem("NRORG"),
      };
      req.callbackSuccess = function (response: any) {
        self.paymentMethods = response.paymentsMethods.paymentMethods;
        self.allPaymentMethods = response.paymentsMethods.paymentMethods;
        sessionStorage.setItem(
          "ACCEPTED_PAYMENT_METHODS",
          JSON.stringify(response.paymentsMethods.paymentMethods)
        );
        sessionStorage.setItem(
          "ALL_PAYMENT_METHODS",
          JSON.stringify(response.paymentsMethods.paymentMethods)
        );
        self.getCreditCards();
        self.getDeliveryPaymentMethod();
        self.getPixPaymentMethod();
        self.getPersonalCreditAndConsumerDebitPaymentMethod();
      };
      req.callbackError = function (error: any) {
        console.log(error);
      };
      req.blockTouchEvents = false;
      req.send();
    } catch (e) {
      console.log(e);
    }
  }

  get paymentMethodsOnDelivery() {
    const payments = this.paymentMethods.filter((payment: any) => {
      if (payment.PAYMENT_METHOD) {
        return payment.PAYMENT_METHOD.includes("EXT");
      }
    });
    return payments;
  }

  getCreditCards() {
    try {
      const self = this;
      const req = new Request();
      req.body = {
        USER_ID: sessionStorage.getItem("USER_ID"),
        TOKEN: sessionStorage.getItem("TOKEN"),
        NRORG: sessionStorage.getItem("NRORG"),
        STORE_ID: this.store.id ? this.store.id : null,
      };
      req.route = "getValidCreditCard";
      req.callbackSuccess = (response: any) => {
        /* VariÃ¡vel que armazena todos os cartÃµes do usuÃ¡rio e de seu titular (caso aplique) */
        self.cards = response.creditcards;
        const allCards = response.creditcards;
        if (response.creditcardFromParent)
          allCards.push(response.creditcardFromParent);

        /* Identificando cartÃ£o principal */
        self.mainCartao = {};
        allCards.forEach((card: any) => {
          if (card.IS_MAIN_CARD == true) self.mainCartao = card;
        });

        /* VariÃ¡vel que armazena o indÃ­ce de 'CC' nos mÃ©todos de pagamento */
        const aceitaCC = self.paymentMethods.findIndex(
          (paymentMethod: any) => paymentMethod.PAYMENT_METHOD == "CC"
        );

        /* Carregar cartÃµes do usuÃ¡rio no select caso CC seja uma das formas de pagamento aceitas */
        if (aceitaCC != -1) {
          self.paymentMethods = allCards.concat(self.paymentMethods);
        }

        if (self.hasGatway) {
          self.showPaymentWithApp = self.paymentMethods.findIndex(
            (p: any) => p.PAYMENT_METHOD == "CC" || p.FLAG
          );
          self.showPaymentVoucher = self.paymentMethods.findIndex(
            (p: any) => p.PAYMENT_METHOD && p.PAYMENT_METHOD.includes("VOUCHER")
          );
          self.showPaymentOnDelivery = self.paymentMethods.findIndex(
            (p: any) => p.PAYMENT_METHOD && p.PAYMENT_METHOD.includes("EXT")
          );
        } else {
          self.showPaymentWithApp = -1;
          self.showPaymentOnDelivery = self.paymentMethods.findIndex(
            (p: any) =>
              (p.PAYMENT_METHOD && p.PAYMENT_METHOD.includes("EXT")) || p.FLAG
          );
        }
        if (!this.hasAnyPaymentOnApp() && this.hasAnyPaymentOnDelivery()) {
          this.tab = 1;
        }

        sessionStorage.setItem("ALL_CC", JSON.stringify(allCards));
        sessionStorage.setItem("MAIN_CARTAO", JSON.stringify(self.mainCartao));
        sessionStorage.setItem("ACEITA_CC", JSON.stringify(aceitaCC));
        sessionStorage.setItem(
          "CREDIT_CARDS",
          JSON.stringify(self.cards || [])
        );
      };
      req.callbackError = (error: any) => {
        if (!this.hasAnyPaymentOnApp() && this.hasAnyPaymentOnDelivery()) {
          this.tab = 1;
        }
        console.log(error);
      };
      req.showLoader = false;
      req.blockTouchEvents = false;
      if (sessionStorage.getItem("USER_ID")) req.send();
    } catch (e) {
      console.log(e);
    }
  }

  deleteCC() {
    try {
      const self = this;
      const req = new Request();
      req.body = {
        CREDITCARD_ID: this.CREDIT_CARD_ID,
        USER_ID: sessionStorage.getItem("USER_ID") || "",
        TOKEN: sessionStorage.getItem("TOKEN") || "",
        NRORG: sessionStorage.getItem("NRORG"),
      };
      req.route = "deleteCC";
      req.callbackSuccess = function (response: any) {
        self.fechaModal();
        self.getCreditCards();
        sessionStorage.removeItem("METHOD_SELECTED");
        sessionStorage.removeItem("FULL_METHOD_SELECTED");
        window.location.reload();
      };
      req.callbackError = function (error: any) {
        console.log(error);
      };
      req.blockTouchEvents = false;
      req.send();
    } catch (e) {
      console.log(e);
    }
  }

  getDeliveryPaymentMethod() {
    this.showPaymentDelivery = this.paymentMethods.findIndex((p: any) =>
      p.PAYMENT_METHOD.startsWith("EXT_")
    );
    this.paymentMethods.map((payment: any) => {
      if (payment.PAYMENT_METHOD.includes("EXT")) {
        this.deliveryPaymentMethods.push(payment);
      }
    });
  }

  getPixPaymentMethod() {
    this.showPaymentDelivery = this.paymentMethods.findIndex((p: any) =>
      p.PAYMENT_METHOD.startsWith("PIX")
    );
    this.paymentMethods.map((payment: any) => {
      if (payment.PAYMENT_METHOD.includes("PIX")) {
        this.pixPaymentMethods.push(payment);
      }
    });
  }

  getPersonalCreditAndConsumerDebitPaymentMethod() {
    this.showPaymentDelivery = this.paymentMethods.findIndex(
      (p: any) =>
        p.PAYMENT_METHOD.startsWith("PERSONAL_CREDIT") ||
        p.PAYMENT_METHOD.startsWith("CONSUMER_DEBT")
    );
    this.paymentMethods.map((payment: any) => {
      if (
        payment.PAYMENT_METHOD.includes("PERSONAL_CREDIT") ||
        payment.PAYMENT_METHOD.includes("CONSUMER_DEBT")
      ) {
        this.personalCreditAndConsumerDebitPaymentMethods.push(payment);
      }
    });
  }

  choiceThisPaymentMethod(id: any) {
    this.fullMethodSelected = this.paymentMethods.find(
      (payment: any) => payment.ID == id
    );

    const currentOrder = JSON.parse(
      sessionStorage.getItem("CURRENT_ORDER") || "{}"
    );
    if (currentOrder && currentOrder.TOTAL_VALUE) {
      if (
        parseFloat(this.fullMethodSelected.MIN_PAYMENT_VALUE) >
        parseFloat(currentOrder.TOTAL_VALUE)
      ) {
        this.showModalMinimumPaymentError = true;
        this.errorMessage = `Valor minimo para compras neste método de pagamento é de R$ ${parseFloat(
          this.fullMethodSelected.MIN_PAYMENT_VALUE.replace(".", ",")
        )}`;
        return;
      }
    }

    /* If selected Method is a card */
    if (this.fullMethodSelected.FLAG) {
      const paymentMethod = this.allPaymentMethods.find(
        (method: any) => method.PAYMENT_METHOD == "CC"
      );

      if (paymentMethod && paymentMethod.MIN_PAYMENT_VALUE) {
        this.fullMethodSelected.MIN_PAYMENT_VALUE =
          paymentMethod.MIN_PAYMENT_VALUE;
        sessionStorage.setItem(
          "FULL_METHOD_SELECTED",
          JSON.stringify(this.fullMethodSelected)
        );
      }

      if (currentOrder && currentOrder.TOTAL_VALUE) {
        if (
          parseFloat(paymentMethod.MIN_PAYMENT_VALUE) >
          parseFloat(currentOrder.TOTAL_VALUE)
        ) {
          this.showModalMinimumPaymentError = true;
          this.errorMessage = `Valor minimo para compras neste método de pagamento é de R$ ${parseFloat(
            paymentMethod.MIN_PAYMENT_VALUE.replace(".", ",")
          )}`;
          return;
        }
      }

      this.paymentMethodSelected = this.fullMethodSelected.ID;
      this.CREDIT_CARD_ID = id;
      this.LAST_NUMBERS = this.fullMethodSelected.LAST_NUMBERS;
      this.FLAG_CARD = this.fullMethodSelected.FLAG;

      sessionStorage.setItem(
        "METHOD_SELECTED",
        JSON.stringify(this.paymentMethodSelected)
      );
      sessionStorage.setItem("METHOD_ID", JSON.stringify(paymentMethod.ID));
      sessionStorage.setItem(
        "MAIN_CARTAO",
        JSON.stringify(this.fullMethodSelected)
      );
      this.changeMainCard();
    } else if (this.fullMethodSelected.PAYMENT_METHOD == "CC") {
      this.goToAddCard();
    } else {
      this.paymentMethodSelected = this.fullMethodSelected.PAYMENT_METHOD;
      sessionStorage.setItem(
        "METHOD_SELECTED",
        JSON.stringify(this.paymentMethodSelected)
      );
      sessionStorage.setItem("METHOD_ID", id);
    }

    if (this.fullMethodSelected.PAYMENT_METHOD != "CC") {
      sessionStorage.setItem(
        "FULL_METHOD_SELECTED",
        JSON.stringify(this.fullMethodSelected)
      );
    }
    if (this.hasPixel) {
      fbq("track", "AddPaymentInfo");
    }
    this.goToPedido();
  }

  lastNumberCard(lastNumbers: any) {
    const lastNumber =
      "0000".substring(0, 4 - String(lastNumbers).length) + lastNumbers;
    return lastNumber;
  }

  mostraModal(id: number, cardNumber: number) {
    this.CREDIT_CARD_ID = id;
    this.LAST_NUMBERS = cardNumber;
    this.showModal = true;
  }

  setSelectedCard(id: number, cardNumber: number, flag: any) {
    this.CREDIT_CARD_ID = id;
    this.LAST_NUMBERS = this.lastNumberCard(cardNumber);
    this.FLAG_CARD = flag;
    this.fullMethodSelected = this.cards.find(
      (card: any) => card.ID == this.CREDIT_CARD_ID
    );
    sessionStorage.setItem(
      "MAIN_CARTAO",
      JSON.stringify(this.fullMethodSelected)
    );
    sessionStorage.setItem(
      "FULL_METHOD_SELECTED",
      JSON.stringify(this.fullMethodSelected)
    );
    sessionStorage.setItem(
      "METHOD_SELECTED",
      JSON.stringify(this.fullMethodSelected.ID)
    );

    this.changeMainCard();
    this.goBack();
  }

  fechaModal() {
    this.showModal = false;
    this.modalConfirm = false;
    this.modalVerify = false;
  }

  goBack() {
    this.$router.go(-1);
  }

  goToMenu() {
    const majorRoute = JSON.parse(
      sessionStorage.getItem("WHICH_ROUTE_CAME_TO_PEDIDO") || "{}"
    );

    if (majorRoute.includes("/ListaDeProdutos")) {
      this.$router.replace(majorRoute);
    } else {
      sessionStorage.setItem("ENTERED_FROM_ORDER", "true");
      if (this.$route.params.idTable) {
        this.$router.push({
          name: "Produtos",
          params: {
            idStore: this.$route.params.idStore,
            idTable: this.$route.params.idTable,
          },
        });
      } else {
        this.$router.replace("Produtos");
      }
    }
  }

  goToPedido() {
    this.$router.push({ name: "Pedido" });
  }

  goToAddCard() {
    const fullMethodSelectedCC = this.paymentMethods.find(
      (payment: any) => payment.PAYMENT_METHOD == "CC"
    );

    const currentOrder = JSON.parse(
      sessionStorage.getItem("CURRENT_ORDER") || "{}"
    );
    if (currentOrder && currentOrder.TOTAL_VALUE) {
      if (
        parseFloat(fullMethodSelectedCC.MIN_PAYMENT_VALUE) >
        parseFloat(currentOrder.TOTAL_VALUE)
      ) {
        this.showModalMinimumPaymentError = true;
        this.errorMessage = `Valor minimo para compras neste método de pagamento é de R$ ${parseFloat(
          fullMethodSelectedCC.MIN_PAYMENT_VALUE.replace(".", ",")
        )}`;
        return;
      }
    }

    sessionStorage.setItem("FLAG_VR", "");
    this.$router.push({ name: "AddCard" });
  }

  goToAddVr() {
    const fullMethodSelectedVr = this.paymentMethods.find(
      (payment: any) =>
        payment.PAYMENT_METHOD && payment.PAYMENT_METHOD.includes("VOUCHER")
    );

    const currentOrder = JSON.parse(
      sessionStorage.getItem("CURRENT_ORDER") || "{}"
    );
    if (currentOrder && currentOrder.TOTAL_VALUE) {
      if (
        parseFloat(fullMethodSelectedVr.MIN_PAYMENT_VALUE) >
        parseFloat(currentOrder.TOTAL_VALUE)
      ) {
        this.showModalMinimumPaymentError = true;
        this.errorMessage = `Valor minimo para compras neste método de pagamento é de R$ ${parseFloat(
          fullMethodSelectedVr.MIN_PAYMENT_VALUE.replace(".", ",")
        )}`;
        return;
      }
    }

    sessionStorage.setItem("FLAG_VR", "VOUCHER");
    this.$router.push({ name: "ChooseVoucher" });
  }

  goToExtrato() {
    this.$router.push({ name: "Extrato" });
  }

  changeMainCard() {
    try {
      const self = this;
      const req = new Request();
      req.body = {
        CREDITCARD_ID: this.CREDIT_CARD_ID || "",
        USER_ID: sessionStorage.getItem("USER_ID") || "",
        TOKEN: sessionStorage.getItem("TOKEN") || "",
        NRORG: sessionStorage.getItem("NRORG"),
      };
      req.route = "setMainCreditCard";
      req.callbackSuccess = function (response: any) {
        self.fullMethodSelected = self.cards.find(
          (card: any) => card.ID == self.CREDIT_CARD_ID
        );
        self.paymentMethodSelected = self.fullMethodSelected.ID;
        // sessionStorage.setItem('FULL_METHOD_SELECTED', JSON.stringify(self.fullMethodSelected));
        // sessionStorage.setItem('METHOD_SELECTED', self.paymentMethodSelected);
        self.getCreditCards();
      };
      req.callbackError = function (error: any) {
        console.log(error);
      };
      req.showLoader = false;
      req.blockTouchEvents = false;
      req.send();
    } catch (e) {
      console.log(e);
    }
  }

  deletarCard(cardId: number) {
    const card = this.cards.find((c: any) => c.ID == cardId);
    this.CREDIT_CARD_ID = cardId;
    this.FLAG = card.FLAG;
    this.LAST_NUMBERS = card.LAST_NUMBERS;
    this.showModal = true;
  }

  mostraModalCpf(message: string) {
    this.errorMessage = message;
    this.showModalCpf = true;
  }

  fechaModalCpf() {
    this.showModalCpf = false;
  }

  validateCpf() {
    const cpf = this.cpf.replace(/[^\d]+/g, "");
    const paymentId: any = Number(sessionStorage.getItem("PIX_ID"));

    if (cpf == "") {
      this.cpfError = "Digite um cpf válido";
      return false;
    }
    // Elimina CPFs invalidos conhecidos
    if (
      cpf.length != 11 ||
      cpf == "00000000000" ||
      cpf == "11111111111" ||
      cpf == "22222222222" ||
      cpf == "33333333333" ||
      cpf == "44444444444" ||
      cpf == "55555555555" ||
      cpf == "66666666666" ||
      cpf == "77777777777" ||
      cpf == "88888888888" ||
      cpf == "99999999999"
    ) {
      this.cpfError = "Digite um cpf válido";
      return false;
    }
    // Valida 1o digito
    let add = 0;
    for (let i = 0; i < 9; i++) add += parseInt(cpf.charAt(i)) * (10 - i);
    let rev = 11 - (add % 11);
    if (rev == 10 || rev == 11) rev = 0;
    if (rev != parseInt(cpf.charAt(9))) {
      this.cpfError = "Digite um cpf válido";
      return false;
    }
    // Valida 2o digito
    add = 0;
    for (let i = 0; i < 10; i++) add += parseInt(cpf.charAt(i)) * (11 - i);
    rev = 11 - (add % 11);
    if (rev == 10 || rev == 11) rev = 0;
    if (rev != parseInt(cpf.charAt(10))) {
      this.cpfError = "Digite um cpf válido";
      return false;
    } else {
      this.userData.CPF = cpf;
      sessionStorage.setItem("USER_DATA", JSON.stringify(this.userData));
      this.cpfError = "";
      this.fechaModalCpf();
      this.choiceThisPaymentMethod(paymentId);
    }
  }

  checkForCpf(paymentId: any) {
    if (this.userData.CPF == null || this.userData.CPF == "") {
      sessionStorage.setItem("PIX_ID", paymentId);
      this.mostraModalCpf("Para efetuar pagamento por PIX, informe seu CPF:");
    } else {
      this.choiceThisPaymentMethod(paymentId);
    }
  }

  hasAnyPaymentOnDelivery() {
    return this.paymentMethods.some((paymentMethod: any) => {
      const regex = /^EXT/g;
      return regex.test(paymentMethod.PAYMENT_METHOD);
    });
  }

  hasAnyPaymentOnApp() {
    return (
      this.showPaymentWithApp > -1 ||
      this.showPaymentVoucher > -1 ||
      !!this.pixPaymentMethods.length ||
      !!this.personalCreditAndConsumerDebitPaymentMethods.length
    );
  }

  checkPixPending() {
    try {
      const req = new Request();
      req.body = {
        USER_ID: sessionStorage.getItem("USER_ID"),
        NRORG: sessionStorage.getItem("NRORG"),
      };
      req.route = "getUserOrderPixPending";
      req.callbackSuccess = (response: any) => {
        const orders = response.orders;

        if (
          !orders ||
          orders === "Nenhum pedido pix pendente" ||
          orders === "Sem id do usuario ainda" ||
          (Array.isArray(orders) && typeof orders[0] === "string")
        ) {
          const validOrder = orders.find((o: any) => o.order);

          if (validOrder.order.status == 7) {
            this.$toast.error(
              "O pedido " +
                validOrder.order.orderIdentifier +
                " foi cancelado pela falta de pagamento."
            );
            this.$router.push("PedidosRealizados");
          } else {
            this.ordersPixPending = validOrder.order;
            sessionStorage.setItem(
              "QR_CODE_PIX",
              JSON.stringify(validOrder.qrCodePix)
            );
            this.mostraModalPix(
              "O pagamento por PIX para o pedido " +
                validOrder.order.orderIdentifier +
                " ainda está pendente. O que deseja fazer agora?"
            );
          }
        } else {
          this.fechaModalPix();
        }
      };
      req.callbackError = function (error: any) {
        console.log(error);
      };
      req.send();
    } catch (e) {
      console.log(e);
    }
  }

  mostraModalPix(message: string) {
    this.errorMessage = message;
    this.showModalPix = true;
  }

  fechaModalPix() {
    this.showModalPix = false;
  }
}
